import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			hostInject: {},
			adPosConfig: {},
			adsensConfig: {
				home_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				nams_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				nams_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				nams_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				name_detail_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				name_detail_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				name_detail_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_detail_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_detail_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_detail_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_list_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_list_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories_list_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_detail_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_detail_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				blog_detail_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
			},

			domainConfig: {
				showBlog: 1,
				blog: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 71, 72, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100],
				origin: 'English',
				siteName: 'Nameri',
				siteIcon: '/icon/1.svg',
				IAMEMAIL: 'aisweetname.support@gmail.com',
				IAmURL: 'aisweetname.com',
				ABOUTUS: 'Discover elegant and meaningful Japanese names with Namari. We celebrate the beauty of simplicity, tradition, and modern charm in every name.',
				meta: {
					title: ' | Japanese Name Generator AI',
					des: 'Instantly generate beautiful and meaningful Japanese names with our AI-powered tool. Explore traditional, modern, and gender-neutral options.  ',
				},
				firebase: {
					apiKey: 'AIzaSyC1L7aTyfFDWAu4ltkP-VG8Iory1ZXzVXc',
					authDomain: 'web-pub-763-1.firebaseapp.com',
					projectId: 'web-pub-763-1',
					storageBucket: 'web-pub-763-1.firebasestorage.app',
					messagingSenderId: '524573675095',
					appId: '1:524573675095:web:70697cf3608846de009d12',
					measurementId: 'G-32GWT2E2QM',
				},
				ads: 'google.com, pub-3250972082947763, DIRECT, f08c47fec0942fa0',
				adsense: {
					scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3250972082947763',
				},
			},
			gender: [],
			style: [],
			meaning: [],
			nameOverview: {
				total: 0,
				genderDistribution: {},
				styleDistribution: {},
				syllableDistribution: {},
			},
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setHostInject(state, hostInject) {
				state.hostInject = hostInject
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			setGender(state, gender) {
				state.gender = gender
			},
			setStyle(state, style) {
				state.style = style
			},
			setMeaning(state, meaning) {
				state.meaning = meaning
			},
			setNameOverview(state, nameOverview) {
				state.nameOverview = nameOverview
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			hostInject: (state) => state.hostInject,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			gender: (state) => state.gender,
			style: (state) => state.style,
			meaning: (state) => state.meaning,
			nameOverview: (state) => state.nameOverview,
		},
	})
}
